import { useTranslation } from 'react-i18next'
import TabsBar from '../../../../shared/components/atoms/Tabs/TabsBar'

interface IFormCreationNavigation {}

const QuestionNavigationTabs: React.FC<IFormCreationNavigation> = () => {
  const { t } = useTranslation()

  const tabs = [
    {
      title: t('forms.question_content'),
      link: 'content',
      id: 'content',
    },
    {
      title: t('forms.question_settings'),
      link: 'settings',
      id: 'settings',
    },
  ]

  return <TabsBar tabs={tabs} />
}

export default QuestionNavigationTabs
